"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RatingText = exports.FilledStars = exports.EmptyStars = exports.StarsWrapper = exports.StarsContainer = exports.RatingSummaryContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
/**
 * Container for the rating summary with proper left-aligned flex layout
 */
exports.RatingSummaryContainer = styled_1.default.div `
  display: flex;
  align-items: center;
  gap: ${(0, ui_theme_1.fromTheme)('spacing_xsmall')};
`;
exports.StarsContainer = styled_1.default.div `
  display: inline-block;
  width: calc(${(props) => props.size * props.ratingScale}px);
  height: ${(props) => props.size}px;
  flex-shrink: 0; /* Prevent stars from shrinking */
`;
exports.StarsWrapper = styled_1.default.div `
  position: relative;
  width: 100%;
  svg {
    color: ${(0, ui_theme_1.fromTheme)('color_star_ratings')};
  }
`;
exports.EmptyStars = styled_1.default.div `
  position: absolute;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
`;
exports.FilledStars = styled_1.default.div `
  position: absolute;
  width: ${(props) => props.filledPercent};
  white-space: nowrap;
  overflow: hidden;
`;
exports.RatingText = styled_1.default.span `
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_small')};
  line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
`;
//# sourceMappingURL=ProviderRatingSummary.styles.js.map